import { AppProps } from "next/app";
import { Suspense, useEffect, useState } from "react";
import "../styles/index.css";
import "../styles/scss/_color-schemes.scss";
import "../styles/scss/pages.scss";
import "../styles/scss/header.scss";
import "../styles/scss/main.scss";
import "../styles/scss/footer.scss";
import "../components/v2/dialog/_style.scss";
import "../components/range-slider/_style.scss";
import "../styles/scss/career.scss";
import "../styles/scss/career.scss";
import "../styles/scss/blog.scss";
import "../styles/scss/solutions.scss";
import "../styles/scss/comparison.scss";
import "../styles/scss/content.scss";
import "../styles/scss/about-us.scss";
import "../styles/scss/contact-us.scss";
import "../styles/scss/customer.scss";
import "../styles/scss/partner.scss";
import "../styles/scss/platform.scss";
import "../styles/scss/resources.scss";
import "../styles/scss/pricing.scss";
import "../styles/scss/yc-deal.scss";
import "../components/v2/form-checkbox/_style.scss";
import Head from "next/head";
import Script from "next/script";
import "react-multi-carousel/lib/styles.css";
import { mwImage } from "../lib/common";

import packageJson from "../package.json";

const getAppVersion = () => {
  // @ts-ignore
  return packageJson.version;
};

function MyApp({ Component, pageProps }: AppProps) {
  const [isScriptMw, setIsScriptMw] = useState(false);
  const [isScriptGTM, setScriptGTM] = useState(false);
  setTimeout(() => {
    setScriptGTM(true);
  }, 2000);

  setTimeout(() => {
    setIsScriptMw(true);
  }, 5500);

  useEffect(() => {
    if (
      window.location.hostname != "middleware.io" &&
      window.location.hostname != "localhost"
    ) {
      window.location.href = "https://middleware.io/";
    }
    if (window.location.href == "https://middleware.io/sitemap.xml") {
      window.location.href = "https://middleware.io/sitemap-0.xml";
    }

    if (window.top !== window.self) {
      document.write = (...text: string[]) => {};

      window.top.location.href = window.self.location.href;

      setTimeout(() => {
        document.body.innerHTML = "";
      }, 1);

      window.self.onload = () => {
        document.body.innerHTML = "";
      };
    }
  }, []);

  const home = {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    name: "Middleware",
    url: "https://middleware.io/",
    alternateName: "Middleware",
  };

  const home_json = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    id: `https://middleware.io${pageProps?.uri}`,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home Page",
        item: {
          id: `https://middleware.io`,
          type: "WebPage",
        },
      },
    ],
  };
  const pages_json = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    id: `https://middleware.io${pageProps?.uri}`,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Page",
        item: {
          "@type": "WebPage",
          "@id": `https://middleware.io${pageProps?.uri}`,
        },
      },
    ],
  };
  const blogjson = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    id: `https://middleware.io${pageProps?.uri}`,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Blog",
        item: {
          id: `https://middleware.io/blog/`,
          type: "Thing",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        name: pageProps?.pageTitle,
        item: {
          id: `https://middleware.io/${pageProps?.uri}`,
          type: "Thing",
        },
      },
    ],
  };
  let homeJson = JSON.stringify(home);
  let ldJson = JSON.stringify(home_json);
  let mainBlogJson = JSON.stringify(blogjson);
  let mainPageJson = JSON.stringify(pages_json);

  return (
    <Suspense>
      <Head>
        <title>
          {pageProps?.metaTitle ||
            "Middleware Observability Platform | Cloud-native Monitoring"}
        </title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width" />
        <link rel="canonical" href={`https://middleware.io${pageProps?.uri}`} />
        <link
          rel="preload"
          href="/assets/fonts/fonts-sf-pro/sf-pro-display-medium-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/assets/fonts/fonts-sf-pro/sfprotext-regular-webfont.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href={"/images/Rethink-Observability-With-AI.webp"}
          as="image"
        />
        <link rel="preload" href={"/images/hero-img-after.svg"} as="image" />
        <link rel="preload" href={"/images/hero-img-before.svg"} as="image" />
        <link rel="icon" href="/favicon/favicon.ico" type="image/x-icon" />
        <link
          rel="shortcut icon"
          href="/favicon/favicon.ico"
          type="image/x-icon"
        />
        <meta
          name="robots"
          content={`${pageProps?.metaRobotsNoindex}, ${pageProps?.metaRobotsNofollow}`}
        />
        <meta name="title" content={pageProps?.metaTitle} />
        <meta name="description" content={pageProps?.description} />
        <meta name="og:site_name" content={"Middleware"} />
        <meta name="og:locale" content={"en_US"} />
        <meta
          property="og:url"
          content={`https://middleware.io${pageProps?.uri}`}
        />
        <meta name="twitter:card" content={"summary_large_image"} />
        <meta property="og:title" content={pageProps?.metaTitle} />
        <meta property="og:description" content={pageProps?.description} />
        <meta
          property="og:type"
          content={pageProps?.ogType ? pageProps?.ogType : "website"}
        />
        <meta
          property="og:image"
          content={
            pageProps?.ogImage != null
              ? mwImage(pageProps?.ogImage)
              : "https://middleware.io/wp-content/uploads/2024/08/middleware-observability-thumbnail.png"
          }
        />
        <meta name="twitter:description" content={pageProps?.description} />
        <meta name="twitter:title" content={pageProps?.metaTitle} />
        <meta
          name="twitter:image"
          content={
            pageProps?.ogImage != null
              ? mwImage(pageProps?.ogImage)
              : "https://middleware.io/wp-content/uploads/2024/08/middleware-observability-thumbnail.png"
          }
        />
        {pageProps?.faqSchema != null && (
          <script type="application/ld+json">{pageProps?.faqSchema}</script>
        )}
      </Head>

      {isScriptMw && (
        <Script
          type={"text/javascript"}
          strategy="lazyOnload"
          src={
            "https://cdnjs.middleware.io/browser/libs/0.0.2/middleware-rum.min.js"
          }
        />
      )}
      {isScriptMw && (
        <Script
          type={"text/javascript"}
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
                setTimeout(function() {
                  if (window.Middleware) {
                    Middleware.track({
                      serviceName:"Middleware website and docs",
                      projectName:"Middleware website and docs",
                      accountKey: "ojcwvgdtrejargoqitdvgywopkdqxjxjuxur",
                      target: "https://p2i13hg.middleware.io",
                      vcsCommitSHA: "6297167bf0d4ece1235154b4c3fdbefd2d5ef3c8",
                      vcsRepositoryURL: "https://github.com/middleware-labs/mw-website-nextjs",
                      tracePropagationTargets: [/middleware.io/i],
                      defaultAttributes: {
                        "app.version": "${getAppVersion()}_website",
                        "source": "mw-website", 
                      }
                    });
                  }
                }, 1000);
            `,
          }}
          async
        />
      )}
      {isScriptGTM && (
        <Script strategy="lazyOnload" id="gtm-script" async>
          {`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KKBGSWD');
        `}
        </Script>
      )}


    {setScriptGTM && (
      <Script
        type={"text/javascript"}
        strategy="lazyOnload"
        src={
          "https://embed.reddit.com/widgets.js"
        }
      />
    )}

      {/* {isScriptMw && (
        <Script
          type="text/javascript"
          strategy="lazyOnload"
          async
          dangerouslySetInnerHTML={{
            __html: `
              (function(){
                window.acquire = window.acquire || [{s:Date.now()}];
                var load=function(){
                  var script="https://a8ckom.acquire.io/widget.js";
                  var x=document.createElement('script');
                  x.src=script;x.async=true;
                  var sx=document.getElementsByTagName('script')[0];
                  sx.parentNode.insertBefore(x, sx);
                };
                if(document.readyState === "complete")
                  load();
                else if (window.addEventListener)
                  window.addEventListener('load',load,false);
                else if (window.attachEvent) {
                  window.attachEvent("onload", load);
                }
              })()
            `,
          }}
        />
      )} */}
      <Script
        type={"application/ld+json"}
        dangerouslySetInnerHTML={{ __html: `${homeJson}` }}
      ></Script>
      {pageProps?.uri !== "/" && pageProps?.uri !== "/blog" && (
        <Script
          type={"application/ld+json"}
          dangerouslySetInnerHTML={{ __html: `${mainPageJson}` }}
        ></Script>
      )}
      {pageProps?.uri == "/blog" && (
        <Script
          type={"application/ld+json"}
          dangerouslySetInnerHTML={{ __html: `${mainBlogJson}` }}
        ></Script>
      )}
      {pageProps?.uri == "/" && (
        <Script
          type={"application/ld+json"}
          dangerouslySetInnerHTML={{ __html: `${ldJson}` }}
        ></Script>
      )}
      {/*{pageProps?.uri  == '/blog' && <Script type={"application/ld+json"} dangerouslySetInnerHTML={{__html:`${ArticeldJson}`}} async></Script>}*/}
      {isScriptMw && (
        <Script
          type={"text/javascript"}
          id={"cookieyes"}
          src={
            "https://cdn-cookieyes.com/client_data/1366a05e1d6c4c38f5f2bcff/script.js"
          }
        />
      )}

      <style jsx global>{`
        @font-face {
          font-family: "sfpro-display";
          src: url("/assets/fonts/fonts-sf-pro/sf-pro-display-medium-webfont.woff2");
          font-weight: 510;
          font-display: fallback;
        }
        @font-face {
          font-family: "sfpro-text";
          src: url("/assets/fonts/fonts-sf-pro/sfprotext-regular-webfont.woff2");
          font-weight: 400;
          font-display: fallback;
        }
        h1,
        h2,
        h3,
        h4 {
          font-family: "sfpro-display";
          span {
            font-weight: 510 !important;
            font-family: "sfpro-display";
          }
        }
        header .top-nav .nav-items .nav-links ul li {
          margin-right: 54px;
          font-size: 18px;
          color: #121127;
          font-weight: 500;
          cursor: default;
          position: relative;
        }

        .ahref-btn,
        button {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 16px;
          color: black;
          font-weight: 400;
          &.primary {
            background-color: var(--color-primary);
            color: var(--color-white);
          }
          &.secondary {
            background-color: var(--color-neutrals-100);
          }
        }
        * {
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          box-sizing: border-box;
          -webkit-font-smoothing: antialiased;
          outline: none;
          color: var(--color-text);
          font-weight: normal;
          font-family: "sfpro-text";
        }

        body {
          padding: 0;
          margin: 0;
          background: var(--color-white);
          color: var(--color-text);
          font-size: 15px;
          line-height: 1.5;
          -ms-overflow-style: scrollbar;
          font-family: "sfpro-text";
        }

        html {
          scroll-behavior: smooth;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        ul,
        li {
          padding: 0;
          margin: 0;
        }

        @media screen and (min-width: 1200px) {
          .container {
            max-width: 1200px;
            margin-left: auto;
            margin-right: auto;
            width: 100%;
          }
        }

        @media screen and (max-width: 1199px) {
          .container {
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            width: calc(100% - 70px);
          }
        }

        h1 {
          font-size: 64px;
          font-weight: 510;
          line-height: 62px;
          span {
            color: var(--color-primary);
            font-weight: 500;
          }
          @media screen and (max-width: 991px) {
            font-size: 39px;
            line-height: 55px !important;
            margin-bottom: 20px !important;
          }
        }

        h2 {
          font-size: 36px;
          line-height: 52px;
          font-weight: 510;
          span {
            color: var(--color-primary);
            font-weight: 510;
          }
        }

        h3 {
          font-size: 45px;
          line-height: 35px;
          font-weight: 510;
        }

        h4 {
          font-size: 24px;
          font-weight: 510;
        }

        h5 {
          font-size: 20px;
          font-weight: 600;
        }

        h6 {
          font-size: 16px;
          line-height: 20px;
        }

        p {
          font-size: 20px;
          line-height: 30px;
          font-weight: 500;
        }

        main {
          min-height: calc(100vh - 661.1px);
        }

        .middle-wrapper.site-page section:first-child {
          padding-top: 50px;
        }

        @media screen and (max-width: 630px) {
          .middle-wrapper.site-page section:first-child {
            padding-top: 10px;
          }
        }

        @media only screen and (min-width: 1300px) {
          header.header-top {
            height: 143px;
          }
        }

        header .top-nav {
          padding: 20px 0;
        }

        header .top-nav .d-flex {
          align-items: center;
          justify-content: space-between;
        }

        header .top-nav .nav-items .nav-links ul {
          display: flex;
          list-style: none;
        }

        header .top-nav .nav-items .nav-links ul li {
          margin-right: 54px;
          font-size: 16px;
          color: #121127;
          font-weight: 400;
          cursor: default;
          position: relative;
        }

        header .top-nav .nav-items .nav-links ul li.has-dropdown .icon {
          position: absolute;
          top: 10px;
          right: -17px;
        }

        @media screen and (max-width: 768px) {
          header .top-nav .nav-items .nav-links ul li.has-dropdown .icon {
            right: 0;
          }
        }

        header .top-nav .nav-items .nav-links ul li.has-dropdown img {
          width: 27px;
        }

        header .top-nav .nav-items .nav-links ul li a {
          font-size: 16px;
          color: #121127;
          font-weight: 400;
        }

        header .top-nav .nav-items .nav-links ul li:hover {
          cursor: pointer;
        }

        header .top-nav .nav-items .nav-links ul li:hover.has-dropdown .icon {
          transform: rotate(180deg);
          transition: 0.4s;
        }
        header
          .top-nav
          .nav-items
          .nav-links
          ul
          li:hover
          .padding-div
          .dropdown-item {
          transition: opacity 0.3s ease-in-out;
          position: fixed;
          width: 80%;
          top: 50px;
          left: 200px;
          margin-left: auto;
          margin-right: auto;
        }
        header
          .top-nav
          .nav-items
          .nav-links
          ul
          li:hover
          .padding-div
          .dropdown-item.link-clicked {
          display: none;
        }
        @media screen and (max-width: 768px) {
          header .top-nav .nav-items .nav-links button {
            width: 100% !important;
          }
        }

        @media screen and (max-width: 991px) {
          header .padding-div {
            padding: 0;
            font-size: 0;
          }
        }

        header .dropdown-item .inner-wrapper {
          transform: translateY(5%);
          -webkit-transform: translateY(5%);
          animation: slide-in 0.3s forwards;
          -webkit-animation: slide-in 0.3s forwards;
          display: inline-block;
          background-color: lightblue;
        }

        @keyframes slide-in {
          100% {
            transform: translateY(0%);
          }
        }

        @-webkit-keyframes slide-in {
          100% {
            -webkit-transform: translateY(0%);
          }
        }
      `}</style>
      <Component {...pageProps} />
    </Suspense>
  );
  // return <Component {...pageProps} />
}

export default MyApp;
